import classNames from 'classnames'
import ArrowForwardIcon from 'mdi-react/ArrowForwardIcon'
import ContentCopyIcon from 'mdi-react/ContentCopyIcon'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Link } from 'utils-next/routes'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Button, Theme, Typography } from '@mui/material'

import { ScoutingCampaign } from '../../../../../../../../entities-next/scoutingCampaign'
import { getCorporateDetailsPath } from '../../../../../CorporateManager'
import { SUBSPACES_PATH } from '../../../../../SubspaceManager'

export type ScoutingCampaignHeaderInfoProps = ExtendableStyles &
  Testable & {
    scoutingCampaign: ScoutingCampaign
  }

export function ScoutingCampaignHeaderInfo({
  className,
  scoutingCampaign,
  style,
  ...otherProps
}: ScoutingCampaignHeaderInfoProps) {
  const { classes } = useStyles()
  const name = scoutingCampaign.name || 'New Space'
  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    navigator.clipboard.writeText(scoutingCampaign.id.toString())
    e.stopPropagation()
  }

  return (
    <div className={classNames(className, classes.container)} style={style} {...otherProps}>
      <div className={classes.userContent}>
        <Typography variant="h5">{name}</Typography>
      </div>
      <div className={classes.actionContainer}>
        <Button
          variant="contained"
          className={classes.buttonIcon}
          color="info"
          onClick={handleCopy}
          title="Copy Space id"
          size="small"
        >
          <ContentCopyIcon size={16} />
          <span>Copy ID</span>
        </Button>
        <Link to={getCorporateDetailsPath(scoutingCampaign.corporateId)} className={classes.noUnderline}>
          <Button variant="contained" size="small" color="info" className={classes.buttonIcon}>
            <ArrowForwardIcon size={16} />
            <span>Go to corporate</span>
          </Button>
        </Link>
        <Link to={`${SUBSPACES_PATH}?spaceId=${scoutingCampaign.id}`} className={classes.noUnderline}>
          <Button variant="contained" size="small" color="info" className={classes.buttonIcon}>
            <ArrowForwardIcon size={16} />
            <span>Go to subspaces</span>
          </Button>
        </Link>
      </div>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing, palette }: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: spacing(2),
  },
  avatar: {
    width: spacing(6),
    height: spacing(6),
  },
  userContent: {
    marginLeft: spacing(2),
    flex: '1 1 auto',
  },
  extraInfo: {
    display: 'flex',
    marginTop: spacing(0.5),
  },
  extraInfoItem: {
    position: 'relative',
    marginRight: spacing(2),
    ['&:after']: {
      content: '""',
      position: 'absolute',
      left: `calc(100% + ${spacing(2)}px)`,
      marginLeft: spacing(1),
      height: '100%',
      width: 1,
      backgroundColor: palette.grey[300],
    },
    ['&:last-child:after']: {
      display: 'none',
    },
  },
  actionContainer: {
    display: 'flex',
    gap: spacing(2),
  },
  buttonIcon: {
    display: 'flex',
    gap: spacing(1),
    textDecoration: 'none',
  },
  noUnderline: {
    textDecoration: 'none',
  },
}))
